interface IdTokenClaims {
  roles: string[]
}

export default IdTokenClaims;

export function instanceOfIdTokenClaims(object: any): object is IdTokenClaims {
  return "roles" in object;
}